import { VossCreditBehaviour } from "../vossCreditBehaviour";
import { VossCreditKind } from "../vossCreditKind";
import { vossSubscriptionItemTerminationTiming } from "../vossSubscriptionItemTerminationTiming";
import { VossPeriodAnchor } from "../vossPeriodAnchor";

export const TerminationTypes = {
    CurrentPeriodEnd: 0,
    NextPeriodEnd: 1,
    Immediately: 2
};

export const TerminationConfigs = {
    [TerminationTypes.CurrentPeriodEnd]: {
        terminationType: TerminationTypes.CurrentPeriodEnd,
        timing: vossSubscriptionItemTerminationTiming.AtBindingPeriodEnd,
        behaviour: VossCreditBehaviour.Prorate,
        creditKind: VossCreditKind.Normal,
        periodAnchor: VossPeriodAnchor.CurrentPeriod,
        periodIterationCount: 0
    },
    [TerminationTypes.NextPeriodEnd]: {
        terminationType: TerminationTypes.NextPeriodEnd,
        timing: vossSubscriptionItemTerminationTiming.AtBindingPeriodEnd,
        behaviour: VossCreditBehaviour.Prorate,
        creditKind: VossCreditKind.Normal,
        periodAnchor: VossPeriodAnchor.CurrentPeriod,
        periodIterationCount: 1
    },
    [TerminationTypes.Immediately]: {
        terminationType: TerminationTypes.Immediately,
        timing: vossSubscriptionItemTerminationTiming.Immediately,
        behaviour: VossCreditBehaviour.Full,
        creditKind: VossCreditKind.Normal,
        periodAnchor: VossPeriodAnchor.CurrentPeriod,
        periodIterationCount: undefined
    }
};